import { Component, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AboutComponent } from '@core/components/about/about.component';
import { BaseComponent } from '@core/components/base-component';
import { EventHelper } from '@core/helpers/event.helper';
import { WindowHelper } from '@core/helpers/window.helper';
import { EstimateService } from '@shared/services/estimate.service';
import { TotalsDataService } from '@shared/services/total.service';
import { UserService } from '@shared/services/user.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'pop-save-timer',
  templateUrl: './save-timer.component.html',
  styleUrls: ['./save-timer.component.less']
})
export class SaveTimerComponent extends BaseComponent {
  savingStatus: string;

  public constructor(
    private savingData: TotalsDataService,
    private estimateService: EstimateService,
    public dialog: MatDialog,
    private userService: UserService
  ) {
    super();
    this.subscribe(this.savingData.currentSavingStatus.subscribe(savingStatus => (this.savingStatus = savingStatus)));
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'F1') {
      this.showDoc();
      EventHelper.stopEventHere(event);
    }
  }

  public async showDoc() {
    const defaultLang = 'en';
    const { languageCode } = await this.userService.getUserAsync();
    const lang = languageCode ?? defaultLang;

    const docUrl = environment.documentationURL + (lang != defaultLang ? lang : '');
    WindowHelper.openUrlInNewTab(docUrl);
  }

  public showVersion() {
    this.dialog.open(AboutComponent);
  }

  saveChanges() {
    this.estimateService.saveChanges().subscribe();
  }
}
